import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgBinoculars = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M71.043 67.363h2.945c0-5.669 4.638-10.307 10.306-10.307v-2.945c-7.288 0-13.251 5.964-13.251 13.252Z"
        fill="#374151"
      />
      <path
        d="m99.46 55.73-.294-.367c-.074-.074-.148-.221-.221-.295L87.092 40.565l-.074-.074a13.192 13.192 0 0 0-5.227-3.533c-1.84-4.27-6.699-6.405-11.116-4.786-4.564 1.694-6.92 6.7-5.3 11.264a6.245 6.245 0 0 0-.663 1.62c-1.252-1.178-2.872-1.84-4.712-1.84-1.84 0-3.46.736-4.712 1.84-.22-.515-.441-1.104-.662-1.62 1.62-4.564-.736-9.644-5.3-11.264-4.418-1.62-9.277.516-11.117 4.786-1.915.736-3.755 1.914-5.227 3.533L20.687 55.51a18.979 18.979 0 0 0-4.123 11.852c0 10.528 8.614 19.142 19.142 19.142 10.527 0 19.14-8.614 19.14-19.142v-.147c1.4 1.252 3.166 1.988 5.154 1.988s3.755-.736 5.153-1.988v.147c0 10.528 8.614 19.142 19.141 19.142 10.528 0 19.142-8.614 19.142-19.142 0-4.417-1.473-8.466-3.976-11.631ZM84.81 42.48l5.521 6.699c-1.914-.663-3.975-.958-6.037-.958a19.024 19.024 0 0 0-16.711 9.866l-.59-9.13c.222-4.122 2.872-7.73 6.774-9.202 3.902-1.399 8.245-.368 11.043 2.724Zm-13.104-7.51c.662-.221 1.325-.368 1.987-.368 1.473 0 2.945.589 3.976 1.62-1.694-.074-3.387.22-5.006.81a13.385 13.385 0 0 0-4.86 3.091c.222-2.282 1.62-4.343 3.903-5.153ZM60 46.234c2.209 0 4.05 1.84 4.05 4.049l.294 4.859a7.684 7.684 0 0 0-4.418-1.4c-1.62 0-3.165.516-4.417 1.4l.295-4.86c.147-2.281 1.987-4.048 4.196-4.048ZM46.307 34.602c.662 0 1.325.147 1.987.368 2.283.81 3.681 2.871 3.829 5.153a13.384 13.384 0 0 0-4.86-3.092c-1.619-.589-3.312-.883-5.005-.81 1.104-1.03 2.576-1.62 4.049-1.62ZM35.19 42.479c2.798-3.092 7.215-4.123 11.117-2.724 3.902 1.399 6.552 5.006 6.773 9.203l-.59 9.129c-3.238-5.89-9.57-9.866-16.71-9.866-2.136 0-4.123.369-6.038.958l5.448-6.7Zm.516 41.08c-8.908 0-16.197-7.288-16.197-16.197 0-8.907 7.289-16.196 16.197-16.196 8.907 0 16.196 7.289 16.196 16.197 0 8.907-7.288 16.196-16.196 16.196ZM60 66.259a4.776 4.776 0 0 1-4.785-4.786A4.776 4.776 0 0 1 60 56.688a4.776 4.776 0 0 1 4.785 4.785A4.776 4.776 0 0 1 60 66.258Zm24.294 17.3c-8.907 0-16.196-7.288-16.196-16.197 0-8.907 7.288-16.196 16.197-16.196 8.907 0 16.196 7.289 16.196 16.197 0 8.907-7.288 16.196-16.197 16.196Z"
        fill="#374151"
      />
      <path
        d="M22.454 67.363H25.4c0-5.669 4.638-10.307 10.307-10.307v-2.945c-7.289 0-13.252 5.964-13.252 13.252Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgBinoculars;
